/* eslint-disable import/no-cycle */
import api from './api.service';

function index(params) {
  return api.get('/zones/', params);
}

function get(id, params) {
  return api.get(`/zones/${id}`, params);
}

function getZipCodes(id, params) {
  return api.get(`/zones/${id}/zipcodes`, params);
}

function saveZipCodes(id, params) {
  return api.post(`/zones/${id}/zipcodes`, params);
}

function removeZipCodes(id, zipCodeId, params) {
  return api.delete(`/zones/${id}/zipcodes/${zipCodeId}`, params);
}

function create(params) {
  return api.post('/zones', params);
}

function update(id, params) {
  return api.put(`/zones/${id}/update`, params);
}

function remove(id, params) {
  return api.delete(`/zones/${id}`, params);
}

function save(params) {
  return (params.id) ? update(params.id, params) : create(params);
}

export const zonesService = {
  index,
  get,
  create,
  update,
  remove,
  save,
  getZipCodes,
  saveZipCodes,
  removeZipCodes,
};
